import React, { FC, PropsWithChildren } from 'react';
import * as Styled from './AuthLayout.styles';
import gridIcon from '@assets/icons/auth/grid.svg';
import authIcon from '@assets/icons/auth/auth.svg';

interface AuthLayoutProps {
  hideImage?: boolean;
}

const AuthLayout: FC<PropsWithChildren<AuthLayoutProps>> = ({ hideImage = false, children }) => {
  return (
    <Styled.AuthLayoutContainer>
      <Styled.AuthLayoutLeft>
        <Styled.AuthLayoutLeftContainer>
          <Styled.AuthLayoutLeftGridIcon src={gridIcon.src} />
          {!hideImage ? <Styled.AuthLayoutLeftAuthIcon src={authIcon.src} /> : null}
        </Styled.AuthLayoutLeftContainer>
      </Styled.AuthLayoutLeft>

      <Styled.AuthLayoutRight>{children}</Styled.AuthLayoutRight>
    </Styled.AuthLayoutContainer>
  );
};

export default AuthLayout;
